<script setup>
import { computed } from 'vue';
import MultiselectDropdown from '../../../../../shared/components/ui/MultiselectDropdown.vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
  selectedValue: {
    type: [String, Number],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:selectedValue', 'change']);

const listOptions = computed(() => {
  if (
    !props.attribute.attributeValues ||
    !Array.isArray(props.attribute.attributeValues)
  ) {
    return [];
  }
  return props.attribute.attributeValues.map(value => ({
    id: value,
    name: value,
  }));
});

const selectedItem = computed(() => {
  if (!props.selectedValue) return {};
  return {
    id: props.selectedValue,
    name: props.selectedValue,
  };
});

const handleChange = newItem => {
  const newValue = newItem?.id || null;
  emit('update:selectedValue', newValue);
  emit('change', newItem);
};
</script>

<template>
  <div>
    <div @click.prevent>
      <MultiselectDropdown
        :options="listOptions"
        :selected-item="selectedItem"
        :multiselector-title="`Selecionar ${attribute.attributeDisplayName}`"
        :multiselector-placeholder="`Selecionar ${attribute.attributeDisplayName}`"
        :input-placeholder="`Buscar ${attribute.attributeDisplayName.toLowerCase()}...`"
        no-search-result="Nenhum valor encontrado"
        :has-thumbnail="false"
        @select="handleChange"
      />
    </div>
  </div>
</template>
